import inpattribution from "../../../../assets/images/docs/inp-attribution.png";
import * as React from 'react';
export default {
  inpattribution,
  React
};